import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { DIALOG_DATA } from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { ClientsService } from '../../../pages/pages/clients/clients.service';
import { ToasterService } from '../../services/toaster.service';
import { AddEditIdentificationComponent } from '../identification/add-edit-identification/add-edit-identification.component';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';

@Component({
  selector: 'gtapp-company-licence-prompt',
  standalone: false,
  templateUrl: './company-licence-prompt.component.html',
  styleUrl: './company-licence-prompt.component.scss',
})
export class CompanyLicencePromptComponent implements OnInit, OnDestroy {
  licenseReminderField: boolean = false;
  credentialState: string = '';
  constructor(
    @Optional() protected dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public dialogueData: any,
    private toasterService: ToasterService,
    private appService: AppService,
    private dialogService: ModalDialogueService,
    private clientService: ClientsService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    if (this.dialogueData) {
      this.credentialState = this.dialogueData?.credentialState;
    }
  }
  ngOnDestroy(): void {}
  ignoreLicenseCheck(navigate = false) {
    this.dialogRef.close(false);
    if (this.licenseReminderField === true) {
      let params = { stop_notification: 1 };
      this.clientService
        .updateCompanyDetails({}, params)
        .then((response: any) => {
          this.toasterService.setMessage({
            errorMessage: response['message'],
            successMessage: '',
          });
          const userData = this.appService.getUserData();
          userData['checks']['license_reminder'] = false;
          this.appService.setUserData(userData);
        });
    }
    if (navigate) {
      this.router.navigate(['/company-profile']);
    }
  }
  showLicensePopup() {
    const dialogRef = this.dialogService.open(AddEditIdentificationComponent, {
      data: {
        licenseState: this.credentialState,
        showFrom: 'companyProfilePage',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value?.id) this.dialogRef.close(value);
    });
  }
}
